<template>
  <div style="width:100%;position: absolute;height: 100%;">
    <el-dialog :visible.sync="passwordShow" title="修改账号密码">
      <div class="content-row action-row">
        <el-button size="mini" @click="btnPasswordSubmit()" style="width:40%">确认</el-button>
        <el-button size="mini" @click="btnReturn()" style="width:40%">返回</el-button>
      </div>
      <div class="content-row">
        <div class="col-6 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 账号
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="text"
              v-model="account"
              size="medium"
              placeholder="请填写账号"
              validate-event
              show-word-limit
              clearable
            ></el-input>
          </div>
        </div>
        <div class="col-6 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 手机号码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="text"
              v-model="passwordphone"
              size="medium"
              placeholder="请填写手机号码"
              validate-event
              maxlength="11"
              onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
              show-word-limit
              clearable
            ></el-input>
          </div>
        </div>
        <div class="col-6 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 验证码
            </span>
          </div>
          <div class="col-6">
            <el-input type="text" v-model="sms" size="medium" placeholder="请填写验证码" clearable></el-input>
          </div>
          <div class="col-3">
            <input
              v-show="sendAuthCode"
              class="el-input__inner"
              style="height: 35px; line-height: 35px;"
              type="button"
              value="获取验证码"
              @click="go_yz"
            />
            <input
              v-show="!sendAuthCode"
              class="el-input__inner"
              style="height: 35px; line-height: 35px;color:red;border:1px solid red;"
              type="button"
              :value="auth_timetimer"
              @click="go_yz"
            />
          </div>
        </div>

        <div class="col-6 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 新密码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="password"
              v-model="passwordfp1"
              size="medium"
              placeholder="请输入密码"
              show-word-limit
              showPassword
            ></el-input>
          </div>
        </div>
        <div class="col-6 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 确认密码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="password"
              v-model="passwordfp2"
              size="medium"
              placeholder="请再次确认您的密码"
              show-word-limit
              showPassword
              clearable
            ></el-input>
          </div>
        </div>
        <div class="content-row" style="margin-top:15px;text-align: center;">
          <span>申诉成功需重新验证登陆，结果将以电话形式告知，请注意查收。</span>
        </div>
      </div>
    </el-dialog>
    <el-row :gutter="20" style="height:100%;width:100%">
      <el-col :span="24" style="height:100%;width:100%">
        <div
          class="grid-content bg-purple"
          style="height:100%;border-right: 1px solid #ccc;position: relative;width:100%"
        >
          <el-image src="static/image/background.jpg" style="height:100%;width:100%"></el-image>
          <div
            class="grid-content bg-purple"
            style="    position: absolute;
    top: 23%;
    width: 400px;
    right:10%;
    z-index: 111;
        padding: 2%;
    border-radius: 15px;
    background: #FFF;"
          >
            <div class="content-left-row">
              <div class="row-login Eng-wel">Welcome</div>
            </div>
            <div class="content-left-row">
              <div class="row-login">
                <el-input placeholder="请输入登录账号" prefix-icon="el-icon-user-solid" v-model="username"></el-input>
              </div>
            </div>
            <div class="content-row">
              <div class="row-login">
                <!-- style="border: 2px solid #559420;" -->
                <el-input
                  placeholder="请输入登录密码"
                  show-password
                  prefix-icon="el-icon-lock"
                  v-model="password"
                ></el-input>
              </div>
            </div>
            <div class="content-row">
              <div class="row-login">
                <el-input
                  class="col-6"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-success"
                  v-model="verifycode"
                  @keyup.enter.native="Login()"
                ></el-input>
                <div
                  style="padding: 0px 10px;height: 36px;width: 28%;float:right;    border: 1px solid #C0C4CC;
    border-radius: 5px;min-width:100px"
                  class="col-4"
                >
                  <canvas
                    style="diaplay:inline-block;min-width:100px;height:100%;width:100%"
                    id="canvas"
                    @click="canvas"
                  ></canvas>
                </div>
              </div>
            </div>
            <div class="content-row">
              <div class="row-login">
                <div class="content-left-row inline-div">
                  <el-checkbox v-model="isRememberPassword">记住用户名</el-checkbox>
                </div>
                <div class="content-right-row inline-div pointer">
                  <span @click="demo">忘记密码？</span>
                  <span @click="regist">注册账号</span>
                </div>
              </div>
            </div>
            <div class="content-row" style="margin-top:2%">
              <div class="row-login">
                <div class="content-center-row">
                  <button class="pointer login_btn" @click="Login()">登 录</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      username: "",
      password: "",
      verifycode: "",
      isRememberPassword: false,
      imgCode: "",
      show_num: [],
      passwordShow: false, //注册信息 修改账号密码
      passwordphone: "",
      passwordfp1: "",
      passwordfp2: "",
      sms: "",
      sendAuthCode: "",
      auth_timetimer: 0,
      sendAuthCode: true,
      account: ""
    };
  },
  watch: {},
  mounted() {
    this.view();
  },
  methods: {
    view() { 
      this.username = $.cookie("name") == undefined ? '' : $.cookie('name');
      this.password = $.cookie("pwd") == undefined ? '' : $.base64.decode($.cookie('pwd'));
      if (this.username != null && this.password != null) {
        this.isRememberPassword = true;
      }
      this.canvas();
      // this.getImgCode();
    },

    getImgCode() {
      var num = Math.ceil(Math.random() * 10);
      this.imgCode =
        "http://tcgroup.all2best.com/index.php/index/login/captcha?num = " +
        num;
      //http://tcgroup.all2best.com/index.php/index/login/captcha?num
      this.draw(this.show_num);
    },
    Login() {
      var num = this.show_num.join("");
      if (this.verifycode == "") {
        this.$message1("请输入验证码！");
        // alert("请输入验证码！");
      } else if (this.verifycode != num) {
        this.$message1("验证码错误！请重新输入！");
        this.verifycode = "";
        this.draw(this.show_num);
      } else {
        this.$axios({
          method: "post",
          url: "/index/login/index",
          params: {
            username: this.username,
            password: this.password,
            verifyCode: this.verifycode
          }
        })
          .then(res => {
            if (res.data.status == "ok") { 
              // if (this.isRememberPassword == true) {
              //   this.$cookies.set("name", this.username);
              //   this.$cookies.set("pwd", this.password);
              // } else {
              //   this.$cookies.remove("name");
              //   this.$cookies.remove("pwd");
              // }
              this.$message1(res.data.msg);
              this.$store.dispatch("setUser", this.username);
              sessionStorage.setItem(
                "user",
                this.$store.getters.getcurrentUser
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 500);
            } else {
              this.$message1(res.data.msg);
             }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
        this.verifycode = "";
        this.draw(this.show_num);
      }
      return;
    },
    canvas() { 
      this.draw(this.show_num);
    },
    draw(show_num) {
      var canvas_width = $("#canvas").width();
      var canvas_height = $("#canvas").height();
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      var sCode = "1,2,3,4,5,6,7,8,9,0";
      var aCode = sCode.split(",");
      var aLength = aCode.length; //获取到数组的长度
      for (var i = 0; i <= 3; i++) {
        var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        var deg = (Math.random() * 30 * Math.PI) / 180; //产生0~30之间的随机弧度
        var txt = aCode[j]; //得到随机的一个内容
        show_num[i] = txt.toLowerCase();
        var x = 10 + i * 20; //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
        context.font = "bold 23px 微软雅黑";
        context.translate(x, y);
        context.rotate(deg);
        // context.fillStyle = randomColor();
        context.fillText(txt, 0, 0);

        context.rotate(-deg);
        context.translate(-x, -y);
      }
      for (var i = 0; i <= 5; i++) {
        //验证码上显示线条
        // context.strokeStyle = randomColor();
        context.beginPath();
        context.moveTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.lineTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.stroke();
      }
      for (var i = 0; i <= 30; i++) {
        context.beginPath();
        var x = Math.random() * canvas_width;
        var y = Math.random() * canvas_height;
        context.moveTo(x, y);
        context.lineTo(x + 1, y + 1);
        context.stroke();
      }
    },
    demo() {
      this.passwordShow = true;
    },
    btnPasswordSubmit() {
      this.$axios({
        method: "post",
        url: "/index/message/valid",
        params: {
          mobile: this.passwordphone,
          code: this.sms
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$axios({
              method: "post",
              url: "/index/login/reset",
              params: {
                account: this.account,
                mobile: this.passwordphone,
                pwd: this.passwordfp1,
                pwd_confirm: this.passwordfp2
              }
            })
              .then(res => {
                this.$message1(res.data.msg);
                if (res.data.status == "ok") {
                  this.passwordShow = false;
                }
              })
              .catch(err => {
                this.$message1(err.response.data.msg);
              });
          } else {
            this.$message1(res.data.msg);
          }
        })
        .catch(err => {
          this.$message1(err.response.data.msg);
        });
    },
    go_yz: function() {
      var _this = this;
      if (_this.passwordphone == "") {
        this.$message1("请填写手机号");
        return;
      } else {
        this.$axios({
          method: "post",
          url: "/index/login/check_mobile",
          params: {
            account: this.account,
            mobile: this.passwordphone
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              /* 获取验证码 */
              _this.sendAuthCode = false;
              _this.auth_timetimer = 60;
              var auth_timetimer = setInterval(() => {
                _this.auth_timetimer--;
                if (_this.auth_timetimer <= 0) {
                  _this.sendAuthCode = true;
                  clearInterval(auth_timetimer);
                }
              }, 1000);
              this.$axios({
                method: "post",
                url: "/index/message/send",
                params: {
                  mobile: this.passwordphone,
                  _method: "post"
                }
              })
                .then(res => {
                  if (res.status == "ok") {
                    this.$message1(res.msg);
                  } else {
                    this.$message1(res.data.msg);
                  }
                })
                .catch(err => {
                  this.$message1(err.response.data.msg);
                });
            } else {
            }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
      }
      return;
    },
    btnReturn() {
      this.passwordShow = false;
    },
    regist() {
      this.$router.push({
        path: "/Register/index"
      });
    },
    RememberPassword() {}
  }
};
</script>
<style lang="less" scoped>
body {
  overflow-y: auto;
}
.login-row {
  width: 100%;
  height: 100%;
  background-image: url(/index/static/image/login-bg.png);
  float: left;
  position: absolute;
  background-repeat: round;
}
.login-white {
  background-image: url(/index/static/image/login-bg2.png);
  width: 70%;
  height: 70%;
  position: absolute;
  background-repeat: round;
  /* margin: 0 auto; */
  margin: 7% 0 0 10%;
}
.login-small {
  background-image: url(/index/static/image/login-bg1.png);
  width: 40%;
  margin: 5% 0 0 15%;
  height: 80%;
  background-repeat: round;
}
.row-login {
  width: 80%;
  /* float: right; */
  margin-left: 10%;
  margin-bottom: 4%;
}
.first-row {
  margin: 6% 5% 5% 0;
}

.el-button {
  width: 50%;
}
.Eng-wel {
  text-align: center;
  font-size: 50px;
  color: #1187c6;
}
.login_btn {
  padding: 10px 23px;
  width: 100%;
  background: #1187c6;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  height: 45px;
}
.inline-div {
  width: 50%;
  font-size: 14px;
  opacity: 0.7;
}
// .row-login .el-input__inner {
//   height: 45px;
// }
.ccc {
  height: 45px;
}
.left_top {
  height: 70%;
  width: 70%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 111;
  margin-left: 15%;
  margin-top: 15%;
}
.el-button {
  width: 40%;
}
.action-row {
  width: 20%;
  float: right;
  margin: -6.5% 4% 0 0;
}
.col-6-dialog span,
.col-6-dialog .el-input,
.col-12-dialog span,
.col-12-dialog .el-input,
.col-12-dialog .el-textarea {
  float: left;
  line-height: 2rem;
}
.col-12-dialog .col-10 {
  margin: 0;
}
.col-6-dialog .col-3 span {
  float: right;
  margin-right: 10%;
  line-height: 2rem;
}
.col-6-dialog .col-3 .redstar {
  float: left;
  display: contents;
}
</style>


// WEBPACK FOOTER //
// src/components/Login/index.vue